import { useContext } from "react";
import { AppContext } from "@/Contexts/AppContext";
/**
 * Network state consumer
 * @example
 * const {status, setStatus} = useNetworkContext()
 *
 * @returns
 */
export function useApp() {
	return useContext(AppContext);
}
